module.exports = __webpack_public_path__ + "img/explicacao8.e80d7400.png";